<script lang="ts">
	import { onMount } from 'svelte';
	import type { PortsResponse } from '@/pocketbase/pocketbase-types';

	// --- Props ---
	let { port }: { port: PortsResponse } = $props();

	// --- Google Maps Setup ---
	// IMPORTANT: Replace with environment variable for security!
	// Example using Vite/SvelteKit: import.meta.env.VITE_GOOGLE_MAPS_API_KEY
	const GOOGLE_MAPS_API_KEY = 'AIzaSyAPyrUJYZIJ1Rj8CV17eWl2O1LLPHqwqMc'; // <-- Replace with env var ideally

	// --- Bindings ---
	let mapElement: HTMLDivElement;

	// --- Lifecycle ---
	onMount(async () => {
		const { setOptions, importLibrary } = await import('@googlemaps/js-api-loader');

		if (!GOOGLE_MAPS_API_KEY) {
			console.error('Google Maps API Key is missing or not configured.');
			// Optionally display an error message to the user in the mapElement
			if (mapElement) {
				mapElement.innerHTML =
					'<p style="color: red; text-align: center; padding: 20px;">Error: Google Maps API Key not configured.</p>';
			}
			return;
		}

		if (!port) {
			console.warn('No ports data provided.');
			// Optionally display a default map or message
			if (mapElement) {
				mapElement.innerHTML =
					'<p style="text-align: center; padding: 20px;">No port data available to display.</p>';
			}
			// You could still load a default map here if desired
			// loadDefaultMap();
			return;
		}

		const targetPort = port; // Get the first port

		// Configure the loader options
		setOptions({
			key: GOOGLE_MAPS_API_KEY
		});

		try {
			// Load all required libraries concurrently
			const [{ Map }, { Geocoder }, { AdvancedMarkerElement }] = await Promise.all([
				importLibrary('maps'),
				importLibrary('geocoding'),
				importLibrary('marker')
			]);

			const geocoder = new Geocoder();
			// Perform geocoding request
			geocoder.geocode({ address: targetPort.name }, (results, status) => {
				if (status === google.maps.GeocoderStatus.OK && results && results[0]) {
					const location = results[0].geometry.location; // Get location from the first result
					const mapOptions: google.maps.MapOptions = {
						center: location, // Center map on the found location
						zoom: 12, // Adjust zoom level as needed (e.g., 12-15 is good for a specific place)
						mapId: 'YOUR_MAP_ID' // Optional: Use a Map ID for custom styling
					};

					// Initialize the map
					const map = new Map(mapElement, mapOptions);

					// Create an advanced marker
					new AdvancedMarkerElement({
						position: location, // Position marker at the found location
						map: map,
						title: targetPort.name // Tooltip on hover
					});
				} else {
					console.error(`Geocode was not successful for "${targetPort.name}". Reason: ${status}`);
					// Fallback: Display a default map or an error message
					displayFallbackMap(Map);
				}
			});
		} catch (error) {
			console.error('Error loading Google Maps libraries or initializing map:', error);
			// Display an error message in the map container
			if (mapElement) {
				mapElement.innerHTML = `<p style="color: red; text-align: center; padding: 20px;">Error loading map. Please check console.</p>`;
			}
		}
	});

	// Helper function for a fallback map (optional)
	function displayFallbackMap(Map: typeof google.maps.Map) {
		if (mapElement) {
			console.warn('Displaying fallback map centered at [0, 0].');
			new Map(mapElement, {
				center: { lat: 0, lng: 0 },
				zoom: 2
			});
			// You could also add a text overlay indicating the failure
			const errorOverlay = document.createElement('p');
			errorOverlay.textContent = 'Could not find location for the specified port.';
			errorOverlay.style.cssText =
				'position: absolute; top: 10px; left: 10px; background: rgba(255,255,255,0.8); padding: 5px; border-radius: 3px; color: orange;';
			mapElement.appendChild(errorOverlay);
		}
	}
</script>

<div bind:this={mapElement} style:height={'100%'} style:width={'100%'}>
	<!-- Map will be rendered here. Initial content can be a loading indicator -->
	<div style="display: flex; justify-content: center; align-items: center; height: 100%;">
		Cargando mapa...
	</div>
</div>
